module.exports = __webpack_public_path__ + "static/media/check.ee18f637.svg";